
@file:Suppress("unused")
package tk.mallumo.compose.navigation




/**
 * @see ui.app.assign.AppAssignListingUI
 * @see ui.app.assign.AppAssignListingArgs
 */
val Node.Companion.AppAssignListingUI get() = Node("ui.app.assign.AppAssignListingUI") //args: ui.app.assign.AppAssignListingArgs

/**
 * @see ui.app.assign.detail.AppDetailUI
 * @see ui.app.assign.detail.AppDetailArgs
 */
val Node.Companion.AppDetailUI get() = Node("ui.app.assign.detail.AppDetailUI") //args: ui.app.assign.detail.AppDetailArgs

/**
 * @see ui.app.assign.detail.kindergarten.editor.AppKindergartenEditorUI
 * @see ui.app.assign.detail.AppDetailArgs
 */
val Node.Companion.AppKindergartenEditorUI get() = Node("ui.app.assign.detail.kindergarten.editor.AppKindergartenEditorUI") //args: ui.app.assign.detail.AppDetailArgs

/**
 * @see ui.app.assign.detail.kindergarten.preview.AppKindergartenPreviewUI
 * @see ui.app.assign.detail.AppDetailArgs
 */
val Node.Companion.AppKindergartenPreviewUI get() = Node("ui.app.assign.detail.kindergarten.preview.AppKindergartenPreviewUI") //args: ui.app.assign.detail.AppDetailArgs

/**
 * @see ui.app.assign.detail.wheel.editor.AppEditorWheelUI
 * @see ui.app.assign.detail.AppDetailArgs
 */
val Node.Companion.AppEditorWheelUI get() = Node("ui.app.assign.detail.wheel.editor.AppEditorWheelUI") //args: ui.app.assign.detail.AppDetailArgs

/**
 * @see ui.app.assign.detail.wheel.preview.AppPreviewWheelUI
 * @see ui.app.assign.detail.AppDetailArgs
 */
val Node.Companion.AppPreviewWheelUI get() = Node("ui.app.assign.detail.wheel.preview.AppPreviewWheelUI") //args: ui.app.assign.detail.AppDetailArgs

/**
 * @see ui.app.rss.AppRssListingUI
 * @see ui.app.rss.AppRssListingArgs
 */
val Node.Companion.AppRssListingUI get() = Node("ui.app.rss.AppRssListingUI") //args: ui.app.rss.AppRssListingArgs

/**
 * @see ui.app.rss.channel.AppRssListingChannelUI
 * @see ui.app.rss.AppRssListingArgs
 */
val Node.Companion.AppRssListingChannelUI get() = Node("ui.app.rss.channel.AppRssListingChannelUI") //args: ui.app.rss.AppRssListingArgs

/**
 * @see ui.app.rss.instance.AppRssListingInstanceUI
 * @see ui.app.rss.AppRssListingArgs
 */
val Node.Companion.AppRssListingInstanceUI get() = Node("ui.app.rss.instance.AppRssListingInstanceUI") //args: ui.app.rss.AppRssListingArgs

/**
 * @see ui.app.rss.instance.detail.AppRssDetailInstanceUI
 * @see ui.app.rss.instance.detail.AppRssDetailInstanceArgs
 */
val Node.Companion.AppRssDetailInstanceUI get() = Node("ui.app.rss.instance.detail.AppRssDetailInstanceUI") //args: ui.app.rss.instance.detail.AppRssDetailInstanceArgs

/**
 * @see ui.app.visibility.AppVisibilityListingUI
 * @see ui.app.visibility.AppVisibilityListingArgs
 */
val Node.Companion.AppVisibilityListingUI get() = Node("ui.app.visibility.AppVisibilityListingUI") //args: ui.app.visibility.AppVisibilityListingArgs

/**
 * @see ui.campaign.CampaignListingUI
 * @see ui.campaign.CampaignListingArgs
 */
val Node.Companion.CampaignListingUI get() = Node("ui.campaign.CampaignListingUI") //args: ui.campaign.CampaignListingArgs

/**
 * @see ui.campaign.detailv2.editor.CampaignEditorUI
 * @see ui.campaign.detailv2.editor.CampaignEditorArgs
 */
val Node.Companion.CampaignEditorUI get() = Node("ui.campaign.detailv2.editor.CampaignEditorUI") //args: ui.campaign.detailv2.editor.CampaignEditorArgs

/**
 * @see ui.campaign.detailv2.preview.CampaignPreviewUI
 * @see ui.campaign.detailv2.preview.CampaignPreviewArgs
 */
val Node.Companion.CampaignPreviewUI get() = Node("ui.campaign.detailv2.preview.CampaignPreviewUI") //args: ui.campaign.detailv2.preview.CampaignPreviewArgs

/**
 * @see ui.company.CompanyListingUI
 * 
 */
val Node.Companion.CompanyListingUI get() = Node("ui.company.CompanyListingUI") //args: null

/**
 * @see ui.company.detail.CompanyUI
 * @see ui.company.detail.CompanyArgs
 */
val Node.Companion.CompanyUI get() = Node("ui.company.detail.CompanyUI") //args: ui.company.detail.CompanyArgs

/**
 * @see ui.console.ConsoleUI
 * @see ui.console.ConsoleArgs
 */
val Node.Companion.ConsoleUI get() = Node("ui.console.ConsoleUI") //args: ui.console.ConsoleArgs

/**
 * @see ui.dashboard.DashboardUI
 * @see ui.dashboard.ArgsDashboard
 */
val Node.Companion.DashboardUI get() = Node("ui.dashboard.DashboardUI") //args: ui.dashboard.ArgsDashboard

/**
 * @see ui.device.DeviceListingUI
 * @see ui.device.DeviceListingArgs
 */
val Node.Companion.DeviceListingUI get() = Node("ui.device.DeviceListingUI") //args: ui.device.DeviceListingArgs

/**
 * @see ui.device.detail.editor.DeviceEditorUI
 * @see ui.device.detail.editor.DeviceEditorArgs
 */
val Node.Companion.DeviceEditorUI get() = Node("ui.device.detail.editor.DeviceEditorUI") //args: ui.device.detail.editor.DeviceEditorArgs

/**
 * @see ui.device.detail.preview.DevicePreviewUI
 * @see ui.device.detail.DeviceArgs
 */
val Node.Companion.DevicePreviewUI get() = Node("ui.device.detail.preview.DevicePreviewUI") //args: ui.device.detail.DeviceArgs

/**
 * @see ui.hardware.HardwareListingUI
 * 
 */
val Node.Companion.HardwareListingUI get() = Node("ui.hardware.HardwareListingUI") //args: null

/**
 * @see ui.hardware.detail.HardwareDetailUI
 * @see ui.hardware.detail.HardwareDetailArgs
 */
val Node.Companion.HardwareDetailUI get() = Node("ui.hardware.detail.HardwareDetailUI") //args: ui.hardware.detail.HardwareDetailArgs

/**
 * @see ui.home.HomeUI
 * @see ui.ArgsInitial
 */
val Node.Companion.HomeUI get() = Node("ui.home.HomeUI") //args: ui.ArgsInitial

/**
 * @see ui.EmptyUI
 * 
 */
val Node.Companion.EmptyUI get() = Node("ui.EmptyUI") //args: null

/**
 * @see ui.license.LicenseListingUI
 * 
 */
val Node.Companion.LicenseListingUI get() = Node("ui.license.LicenseListingUI") //args: null

/**
 * @see ui.license.detail.LicenseDetailUI
 * @see ui.license.detail.LicenseArgs
 */
val Node.Companion.LicenseDetailUI get() = Node("ui.license.detail.LicenseDetailUI") //args: ui.license.detail.LicenseArgs

/**
 * @see ui.location.LocationListingUI
 * @see ui.location.LocationListingArgs
 */
val Node.Companion.LocationListingUI get() = Node("ui.location.LocationListingUI") //args: ui.location.LocationListingArgs

/**
 * @see ui.location.detail.LocationUI
 * @see ui.location.detail.LocationArgs
 */
val Node.Companion.LocationUI get() = Node("ui.location.detail.LocationUI") //args: ui.location.detail.LocationArgs

/**
 * @see ui.login.LoginUI
 * @see ui.ArgsInitial
 */
val Node.Companion.LoginUI get() = Node("ui.login.LoginUI") //args: ui.ArgsInitial

/**
 * @see ui.report.campaign.ReportCampaignUI
 * @see ui.report.campaign.ReportCampaignArgs
 */
val Node.Companion.ReportCampaignUI get() = Node("ui.report.campaign.ReportCampaignUI") //args: ui.report.campaign.ReportCampaignArgs

/**
 * @see ui.report.device.ReportDeviceAliveUI
 * @see ui.report.device.ReportDeviceArgs
 */
val Node.Companion.ReportDeviceAliveUI get() = Node("ui.report.device.ReportDeviceAliveUI") //args: ui.report.device.ReportDeviceArgs

/**
 * @see ui.report.device.ReportDeviceSystemUI
 * @see ui.report.device.ReportDeviceArgs
 */
val Node.Companion.ReportDeviceSystemUI get() = Node("ui.report.device.ReportDeviceSystemUI") //args: ui.report.device.ReportDeviceArgs

/**
 * @see ui.resource.ResourceListingUI
 * @see ui.resource.ResourceListingArgs
 */
val Node.Companion.ResourceListingUI get() = Node("ui.resource.ResourceListingUI") //args: ui.resource.ResourceListingArgs

/**
 * @see ui.resource.detail.ResourceUI
 * @see ui.resource.detail.ResourceArgs
 */
val Node.Companion.ResourceUI get() = Node("ui.resource.detail.ResourceUI") //args: ui.resource.detail.ResourceArgs

/**
 * @see ui.resource.editor.VisualEditorUI
 * @see ui.resource.editor.VisualEditorArgs
 */
val Node.Companion.VisualEditorUI get() = Node("ui.resource.editor.VisualEditorUI") //args: ui.resource.editor.VisualEditorArgs

/**
 * @see ui.resource.icons.IconsListingUI
 * 
 */
val Node.Companion.IconsListingUI get() = Node("ui.resource.icons.IconsListingUI") //args: null

/**
 * @see ui.server.ServerListingUI
 * 
 */
val Node.Companion.ServerListingUI get() = Node("ui.server.ServerListingUI") //args: null

/**
 * @see ui.server.detail.ServerUI
 * @see ui.server.detail.ServerArgs
 */
val Node.Companion.ServerUI get() = Node("ui.server.detail.ServerUI") //args: ui.server.detail.ServerArgs

/**
 * @see ui.translation.TranslationListingUI
 * 
 */
val Node.Companion.TranslationListingUI get() = Node("ui.translation.TranslationListingUI") //args: null

/**
 * @see ui.user.UserListingUI
 * @see ui.user.UserListingArgs
 */
val Node.Companion.UserListingUI get() = Node("ui.user.UserListingUI") //args: ui.user.UserListingArgs

/**
 * @see ui.user.detail.UserUI
 * @see ui.user.detail.UserArgs
 */
val Node.Companion.UserUI get() = Node("ui.user.detail.UserUI") //args: ui.user.detail.UserArgs
